// extracted by mini-css-extract-plugin
export var addViewLink = "_8-2";
export var availabilityIcon = "_8-17";
export var availabilitySelectionIcon = "_8-16";
export var backButton = "_8-3";
export var backIcon = "_8-10";
export var conversationCount = "_8-4";
export var dragHandle = "_8-6";
export var dropdown = "_8-f";
export var dropdownIcon = "_8-8";
export var dropdownOption = "_8-7";
export var dropdownTriangle = "_8-e";
export var expand = "_8-g";
export var folder = "_8-j";
export var folderItem = "_8-d";
export var icon = "_8-9";
export var iconRow = "_8-a";
export var image = "_8-b";
export var logo = "_8-c";
export var navContainer = "_8-i";
export var navigationFooter = "_8-h";
export var pageShell = "_8-0";
export var pageShellWms = "_8-1";
export var placeholderAvailable = "_8-12";
export var placeholderBox = "_8-15";
export var placeholderBusy = "_8-14";
export var placeholderUnavailable = "_8-13";
export var profile = "_8-l";
export var profileContainer = "_8-n";
export var profileDropdown = "_8-o";
export var profileImage = "_8-m";
export var profileMain = "_8-p";
export var profileSubtitle = "_8-r";
export var profileTitle = "_8-q";
export var reorderIcon = "_8-s";
export var sentLine = "_8-v";
export var settingsHeader = "_8-t";
export var sidenavTextColor = "_8-z";
export var spamLine = "_8-u";
export var subitemWithTag = "_8-5";
export var supportItems = "_8-k";
export var teamText = "_8-11";
export var viewLine = "_8-y";
export var viewLineButton = "_8-x";
export var viewLineButtons = "_8-w";